// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yelw","col":"styles_col__12HQr","actions":"styles_actions__1iRba","conflict":"styles_conflict__2TqTC"};